import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { RegistrationStepService } from './registration-step/registration-step.service';

/**
 * Resolver to set the module path for the registration step service.
 */
export const registrationResolver: ResolveFn<true> = (route, state) => {
  inject(RegistrationStepService).modulePath = route.parent?.routeConfig?.path ?? '';
  return true;
};
